export default {
  '/invoice-loan-list': 'EMPLOYEE',
};
